import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import getters from './getters'
import actions from './actions'
Vue.use(Vuex)

export default new Vuex.Store({
  state:{
    loadingThreadCount: 0,
    stopDo:false,
    currentUser: '',
    eventBus: [],
    webMessageList:[],
    jobState: 0,
  },
  getters,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/vuex/store.js